<router-outlet>
    <app-spinner></app-spinner>
    <ng-http-loader></ng-http-loader>

</router-outlet>